// extracted by mini-css-extract-plugin
export default {"folderItem":"SelectFolderItem_folderItem__W9xHc"};